import { render, staticRenderFns } from "./single-page.vue?vue&type=template&id=ba19da74&scoped=true&"
import script from "./single-page.vue?vue&type=script&lang=js&"
export * from "./single-page.vue?vue&type=script&lang=js&"
import style0 from "./single-page.vue?vue&type=style&index=0&id=ba19da74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba19da74",
  null
  
)

export default component.exports